import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router'
import { SpinnerLoader } from 'shared/ui'
import { logger } from 'shared/lib'
import { ReviewsApi } from 'entities/Review/api/review'
import type { IResponseReview } from 'entities/Review/api/types'
import { ReviewsRoutes } from 'pages/reviews/route/type'
import { ViewReviewContent } from 'pages/reviews/pages/viewReview/ui/ViewReviewContent'

export const ViewReview = () => {
  const { id } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [reviewResponse, setReviewResponse] = useState<IResponseReview | null>(null)

  useEffect(() => {
    if (id) {
      setIsLoading(true)
      setReviewResponse(null)

      ReviewsApi.getReviewById(id, true)
        .then((res) => {
          if (res) {
            setReviewResponse(res.data.data)
          }
        })
        .catch(logger.error)
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      setIsLoading(false)
    }
  }, [id])

  if (isLoading) {
    return <SpinnerLoader ariaLabel={'ViewReview'} />
  }

  if (reviewResponse) {
    return <ViewReviewContent review={reviewResponse} />
  }

  return <Navigate to={`/${ReviewsRoutes.root}`} replace />
}
